import {
  createReportAction,
  deleteReportAction,
  updateReportAction,
} from '@aims/shared/redux-store/reports-store';
import ViewTrainingEventReport from '@aims/shared/reports/training-event/ViewTrainingEventReport';
import useOneM1 from '@aims/shared/shared/use-one-m1';
import useSingleSomethingA10 from '@aims/shared/shared/use-single-something-a10';
import useSingleSomethingUpdatesA10 from '@aims/shared/shared/use-single-something-updates-a10';
import sharedSettings from '@aims/shared/sharedSettings';
import { ArrowLeftOutlined, UpOutlined } from '@ant-design/icons';
import { BackTop, Button, Skeleton, Space } from 'antd';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import TrainEventAdminSection from './TrainEventAdminSection';
import {
  extractTrainingEventReport,
  trainingEventReportQuery,
  trainingEventReportUpdatesSubscription,
} from './constants';
import ReviewButtons from './review-buttons/ReviewButtons';
import useQueryParams from '../../../shared/use-query-params';
import CSPage from '../../../components/CSPage';
import CSPageHeader from '../../../components/CSPageHeader';

const queryId = 'viewTrainingEventReport';

function ViewTrainingEventReportPage() {
  const { reportId } = useParams();

  useSingleSomethingUpdatesA10({
    variables: { _id: reportId },
    subscription: trainingEventReportUpdatesSubscription,
    createAction: createReportAction,
    updateAction: updateReportAction,
    deleteAction: deleteReportAction,
    extractSomething: (resp) => resp?.data?.trainingEventReportUpdatesForAdmin,
    queryId,
    skip: !reportId,
  });
  const { loading: reportLoading } = useOneM1({
    variables: { _id: reportId },
    query: trainingEventReportQuery,
    extract: extractTrainingEventReport,
    queryId,
    fetchPolicy: 'network-only',
    updateAction: updateReportAction,
    skip: !reportId,
    showError: true,
  });
  const report = useSingleSomethingA10('reports', reportId, queryId);

  const query = useQueryParams();
  const backLink = useMemo(() => {
    if (query && query.from) {
      return query.from;
    } else {
      return `/training-event-reports`;
    }
  }, [query]);

  return (
    <>
      <CSPage
        containerStyle={{ width: '100%', maxWidth: 'unset' }}
        title="Training Event Report"
      >
        <CSPageHeader
          titleComponent={null}
          backActions={[
            <Link to={backLink} key="back">
              <Button type="text" icon={<ArrowLeftOutlined />}>
                Go back
              </Button>
            </Link>,
          ]}
        />
        <div style={{ maxWidth: 800, marginLeft: 'auto', marginRight: 'auto' }}>
          {report && (
            <>
              <ReviewButtons report={report} queryId={queryId} />
              <ViewTrainingEventReport
                colors={sharedSettings.colors}
                report={report}
                isAdmin
                adminSection={
                  <TrainEventAdminSection report={report} queryId={queryId} />
                }
              />
            </>
          )}
          {reportLoading && (
            <Space direction="vertical">
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </Space>
          )}
        </div>
        <BackTop>
          <Button shape="circle" icon={<UpOutlined />} />
        </BackTop>
      </CSPage>
      <style jsx global>{`
        @media print {
        }
      `}</style>
    </>
  );
}

export default ViewTrainingEventReportPage;
